<template>
  <Transition name="fade">
    <div :class="{ 'p-8': loading }" class="combo-select">
      <DrLoader v-if="loading" />
      <div v-else-if="!loading && apiIndustries.length">
        <div class="combo-list">
          <div
            v-for="industry in apiIndustries"
            :key="industry.value"
            class="combo-item"
            tabindex="0"
            @click="selectIndustry(industry)"
            @keydown.enter.prevent="selectIndustry(industry)"
          >
            <div>{{ industry.label }}</div>
            <DrIcon svg="angle-right" width="25" height="25" class="combo-icon" />
          </div>
        </div>
      </div>
      <div v-else-if="inputLength && !apiIndustries.length" class="combo-error">
        No matches found.
      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  props: {
    apiIndustries: {
      type: Array,
      default () {
        return []
      },
    },
    inputLength: {
      type: [String, Number],
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      industries: [],
      focus: false,
    }
  },
  methods: {
    selectIndustry (activity) {
      this.$emit('change', activity)
    },
  },
}
</script>

<style scoped>
.combo-icon {
  @apply text-blue-500;
}
</style>
